
<template>
  <div id="app">
    <router-view/>
    <!-- <div class="consult">
<div @click='toTop' class="consultIconTop">
<img :src="consultTop" alt="">
</div>
<img :src="consult" class="consultBg" alt="">
<a href="http://p.qiao.baidu.com/cps/chatIndex?reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2212581364%22%2C%22userId%22%3A%2222872171%22%2C%22pageId%22%3A0%7D" class="consultText" target="_blank">
    <div style="width:20px;margin:auto;">在线咨询</div>
    </a>
</div>

    </div>-->
  </div>
</template>

<script>
import consult from "../src/assets/images/consult.png";

import consultTop from "../src/assets/images/consultTop.png";

export default {
  name: "App",
  data() {
    return {
      consult: consult,
      consultTop: consultTop,
      winHeight:""
    };
  },
  mounted() {
    

    // 获取浏览器的宽高  start
    var winWidth = 0;
    var winHeight = 0;
    function findDimensions() {
      //函数：获取尺寸
      //获取窗口宽度
      if (window.innerWidth) winWidth = window.innerWidth;
      else if (document.body && document.body.clientWidth)
        winWidth = document.body.clientWidth;
      //获取窗口高度
      if (window.innerHeight) winHeight = window.innerHeight;
      else if (document.body && document.body.clientHeight)
        winHeight = document.body.clientHeight;
      //通过深入Document内部对body进行检测，获取窗口大小
      if (
        document.documentElement &&
        document.documentElement.clientHeight &&
        document.documentElement.clientWidth
      ) {
        winHeight = document.documentElement.clientHeight;
        winWidth = document.documentElement.clientWidth;
      }
      //结果输出至两个文本框
      console.log("宽", winWidth);
      console.log("高", winHeight);
      
      
      let scaleNum = winWidth / 980;
      if (scaleNum < 1) {
        document.getElementById("app").style =
          "-webkit-transform: scale(" +
          scaleNum +
          ");-webkit-transform-origin: 0 0;";
        document.body.style = "height:" + winHeight + "px;";
      }
    }
    findDimensions();
    //调用函数，获取数值
    window.onresize = findDimensions;
    // 获取浏览器的宽高 end
  },
  methods: {
    toTop() {
      window.scrollTo(0, 0);
    },
    
  }
};
</script>

<style>
h1 {
  font-size: 3rem;
}

* {
  margin: 0;
  padding: 0;
}
div {
  margin: 0;
  padding: 0;
}
img[lazy="loading"]{
  display:block;
  width:50px !important;
  height:50px !important;
  margin:0 auto;
}

.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 50px !important;
}

.swiper-pagination-bullet {
  width: 95px !important;
  height: 2px !important;
  opacity: 0.5 !important;
  background: #fff !important;
  border-radius: 0 !important;
}

.swiper-pagination-bullet-active {
  background: #fff !important;
  opacity: 1 !important;
}
.swiper-button-next,
.swiper-button-prev {
  top: 43% !important;
}
/* 匀速 start */
.swiper-wrapper {
  -webkit-transition-timing-function: linear !important; /*之前是ease-out*/
  transition-timing-function: linear !important;
}
/* 匀速 end */
#app {
  min-width: 980px;
  text-size-adjust: auto;
}
@media screen and (max-width: 1200px) {
  .swiper-button-next,
  .swiper-button-prev {
    top: 47% !important;
  }
  /* #app{
    zoom: 0.8;
    transform: scale(0.8) ;
    transform-origin: 0px 0px 0px;
    } */
}
@media screen and (max-width: 420px) {
  /* #app{
    zoom: 0.6;
    transform: scale(0.6) ;
    transform-origin: 0px 0px 0px;
    } */
}
#app {
  -webkit-text-size-adjust: none;
  font-size: 62.5% !important;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #333 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #fcc800 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fcc800 !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #fcc800 !important;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 70px !important;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 70px !important;
}
/* 在线咨询按钮 start */
.consult {
  position: fixed;
  bottom: 50px;
  z-index: 100;
  right: 20px;
  height: 167px;
  width: 46px;
}
/* 资讯按钮 适配 start */
@media screen and (max-width: 800px) {
  .consult {
    width: 38px;
    height: 140px;
  }
  .consultBg {
    width: 100%;
  }
  .consultText {
    padding: 0 !important;
    line-height: 19px !important;
  }
  .consultText {
    left: calc(50% - 17px) !important;
  }
}
@media screen and (min-width: 1700px) {
  .consult {
    height: 175px !important;
    width: 50px !important;
  }
  .consultText {
    line-height: 25px !important;
  }
}
/* 资讯按钮 适配 end */
.consultBox {
  position: relative;
}
.consultBg {
  position: absolute;
  z-index: 110;
  width: 100%;
}

.consultIconTop {
  position: absolute;
  z-index: 120;
  top: 14px;
  width: 20px;
  left: calc(50% - 11px);
  cursor: pointer;
}

.consultText {
  text-decoration: none;
  width: 40px;
  padding: 10px 0;
  left: calc(50% - 20px);
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 51px;
  z-index: 130;
  cursor: pointer;
}

/* 在线咨询按钮 end */
</style>



// WEBPACK FOOTER //
// src/App.vue